import { useEffect } from 'react'

export default function useCardPWA(vCard) {
  useEffect(() => {
    if (!vCard || vCard.pwaEnabled !== true) return
    const slug = vCard.slug || ''
    if (!slug) return

    const name = vCard.name || 'Dkard'
    const shortName = name.length > 12 ? name.slice(0, 12) : name
    const startUrl = `/${slug}`
    const scope = `/${slug}/`
    const icon = vCard.photoUrl || vCard.logoUrl || '/LOGODK.png'

    const manifest = {
      name,
      short_name: shortName,
      start_url: startUrl,
      scope,
      display: 'standalone',
      background_color: vCard.theme?.primaryColor || '#2563eb',
      theme_color: vCard.theme?.primaryColor || '#2563eb',
      icons: [
        { src: icon, sizes: '192x192', type: 'image/png' },
        { src: icon, sizes: '512x512', type: 'image/png' }
      ]
    }

    const blob = new Blob([JSON.stringify(manifest)], { type: 'application/manifest+json' })
    const url = URL.createObjectURL(blob)

    let linkEl = document.querySelector('link[rel="manifest"]')
    if (!linkEl) {
      linkEl = document.createElement('link')
      linkEl.setAttribute('rel', 'manifest')
      document.head.appendChild(linkEl)
    }
    linkEl.setAttribute('href', url)

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js').catch(() => {})
    }

    return () => {
      // do not revoke blob immediately to keep manifest available
    }
  }, [vCard])
}
